export default {
    // Admin API에서 가져온 공지/이벤트 전체 목록
    noticeItems: [],
    // 상세 페이지용 현재 선택된 공지
    currentNotice: null,
};
